import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { EditMakeInwinForm } from 'local/components'

import { ContentLoader } from 'shared/components'

import * as styles from './styles'

const MakeInWinAddComponent = ({
  onSubmit,
  getEventInfoById,
  eventId,
  wallet,
  onClose,
}) => {
  const [initialValues, setInitialValues] = useState('')
  useEffect(() => {
    const getData = async () => {
      const eventData = await getEventInfoById(eventId)
      setInitialValues({
        eventData,
        wallet,
        eventId,
      })
    }
    getData()
  }, [])

  return initialValues ? (
    <EditMakeInwinForm
      header="Place Inwin"
      onSubmit={onSubmit}
      initialValues={initialValues}
      onClose={onClose}
    />
  ) : (
    <div css={styles.loaderWrapper}>
      <ContentLoader loading={true} wrapperStyles={{ left: 0, right: 0 }} />
    </div>
  )
}

MakeInWinAddComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  getEventInfoById: PropTypes.func.isRequired,
  eventId: PropTypes.number.isRequired,
  wallet: PropTypes.shape(),
  onClose: PropTypes.func,
}

export default MakeInWinAddComponent
